import { render, staticRenderFns } from "./RoleManagementTab.vue?vue&type=template&id=3b201355&scoped=true"
import script from "./RoleManagementTab.vue?vue&type=script&lang=js"
export * from "./RoleManagementTab.vue?vue&type=script&lang=js"
import style0 from "./RoleManagementTab.vue?vue&type=style&index=0&id=3b201355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b201355",
  null
  
)

export default component.exports